import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {DataTable} from 'primereact/datatable';
import axios from '../../../axios-url';
import {Column} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import {InputMask} from 'primereact/inputmask';
import {  DROPDOWN_CONFIG, VENDOR_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import { filter } from 'lodash';

class Vendor extends Component {
    state = {
        docType : null,
        docDocumentNo : null,
        display : true,
        rows: [],
        type : 'add',
        City : null,
        Country : null,
        vendorId : '',
        vendorNo : '',
        businessType : '',
        vendordocs :[],
        VendorType : null,
        DocExpiryDate : '',
        DocIssuDate : '',
        vendorName : '',
        Address : '',
        billingName : '',
        billingPosition : '',
        billingEmail : '',
        timesheetName : '',
        timesheetPosition : '',
        timesheetEmail : '',
        procurementName : '',
        procurementPosition : '',
        procurementEmail : '',
        actionType : '',
        taxtIn : '',
        CrNo : '',
        bank : '',
        bankBranch : '',
        bankAddress : '',
        bankIban : '',
        isActive : false,
        Blocked : false,
        billingMobile: '',
        timesheetMobile : '',
        procurementMobile : '',
        rowData : null

    }

    

    componentDidMount(){       
        let type = this.props.match.params.type;
        
        if (type !=='add'){
            let vendorId = this.props.match.params.id;
            this.props.getMasterTableList(`Employee/GetVendor?VendorId=${vendorId}`);
        }   
        
        
        
        this.getAccess = HASACCESS(VENDOR_SUBMENU_ID);
        this.props.getMasterKeywordList('City'); 
        this.props.getMasterKeywordList('VendorType');
        this.props.getMasterKeywordList('Country');
        
        if(type !== 'add'&& this.props.tableLists.length>0){
            setTimeout(() => {
                
                this.fetchSingleProcess();
            },1000)
        }
    }

    
    fetchSingleProcess = () =>{
        
        
        let type = this.props.match.params.type;
        let VendorMaster = this.props.tableLists;
        let vendors = VendorMaster.vendor;
        let vendordocuments = [];
        vendordocuments = VendorMaster.vendorDocuments;
        

        
        
        var data = {
                    type:type,
                    
                    vendorId : vendors.vendorId,
                    vendorNo : vendors.vendorNo,
                    VendorType : vendors.businesstype,
                    vendorName : vendors.vendorName,
                    Address : vendors.address,
                    billingName : vendors.contactPersonBilling,
                    billingPosition : vendors.contactPositionBilling,
                    billingEmail : vendors.emailBilling,
                    timesheetName : vendors.contactPersonTimesheet,
                    timesheetPosition : vendors.contactPositionTimesheet,
                    timesheetEmail : vendors.emailTimesheet,
                    procurementName : vendors.contactPersonProcurement,
                    procurementPosition : vendors.contactPositionProcurement,
                    procurementEmail : vendors.emailProcurement,
                    actionType : vendors.actionType,
                    taxtIn : vendors.taxtin,
                    CrNo : vendors.crno,
                    bank : vendors.bank,
                    bankBranch : vendors.bankbranch,
                    bankAddress : vendors.bankaddress,
                    bankIban : vendors.bankiban,
                    isActive : vendors.isactive,
                    Blocked : vendors.blocked,
                    billingMobile: vendors.contactnumberbilling,
                    timesheetMobile : vendors.contactnumbertimesheet,
                    procurementMobile : vendors.contactnumberprocurement,
                    City : vendors.city,
                    Country : vendors.country,
                    vendordocs :  vendordocuments,
                    
                    vid : vendors.id
                    

                    
                    

                }
                this.setState(data);
                
                
            }
        




    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }
    // DocIssuDate: (this.state.DocIssuDate!==null) ? new Date(this.state.DocIssuDate) : '', DocExpiryDate: (this.state.DocExpiryDate!==null) ? new Date(this.state.DocExpiryDate) : ''

    documentAdd = () => {

        let newDoc = { docType: this.state.docType, docDocumentNo: this.state.docDocumentNo };
  
        let docValue = [...this.state.vendordocs, newDoc];
      
        this.setState({vendordocs:docValue})
    }

    addVisaQuota = () => {

        let newDoc = {visaType : this.state.visaType, usedQ:this.state.usedQ,balanceQ:this.state.balanceQ,allocated:0};
        let docValue = [...this.state.VisaQuota, newDoc];
        this.setState({VisaQuota:docValue,usedQ:'',balanceQ:'',allocated:''})
    }

    docActionTemplate = (rowData, column) => {
        
        let rowIndex = column.rowIndex;
        
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteDocType(rowIndex)}></Button>
        </div>;
    }

    
    typeEditor = (props) => {
        let types = [
            {label:'Own',value:'Own'},
            {label:'Dependent',value:'Dependent'}
        ];

        return (
            <Dropdown value={props.value[props.rowIndex].depType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }

    docTypeEditor = (props) => {
        let types = [
            {label:'Passport',value:'Passport'},
            {label:'Driving License',value:'Driving License'},
            {label:'Iqama',value:'Iqama'}
        ];

        return (
            <Dropdown value={props.value[props.rowIndex].documentType} options={types}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }

    deleteDocType = (removeIndex) => {

        const updatedVendorValue = this.state.vendordocs.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({vendordocs:updatedVendorValue})

    }

    add = () => {
        

        let VendorDocuments = []
        let Vendor = {
            
            VendorNo : this.state.vendorNo,
            Businesstype : this.state.VendorType,
            VendorName : this.state.vendorName,
            Address : this.state.Address,
            City : this.state.City,
            Country : this.state.Country,
            ContactPersonBilling : this.state.billingName,
            ContactPositionBilling : this.state.billingPosition,
            EmailBilling : this.state.billingEmail,
            ContactPersonTimesheet : this.state.timesheetName,
            ContactPositionTimesheet : this.state.timesheetPosition,
            EmailTimesheet : this.state.timesheetEmail,
            ContactPersonProcurement : this.state.procurementName,
            ContactPositionProcurement  : this.state.procurementPosition,
            EmailProcurement : this.state.procurementEmail,
            ActionType : this.state.actionType,
            Taxtin : this.state.taxtIn,
            Crno : this.state.CrNo,
            Bank : this.state.bank,
            Bankbranch : this.state.bankBranch,
            Bankaddress : this.state.bankAddress,
            Bankiban : this.state.bankIban,
            Isactive : this.state.isActive,
            Blocked : this.state.Blocked,
            Contactnumberbilling: this.state.billingMobile,
            Contactnumbertimesheet : this.state.timesheetMobile,
            Contactnumberprocurement : this.state.procurementMobile
        }
        
        VendorDocuments = this.state.vendordocs.map(list => {
            return {
                
                
                DocType :list.docType,
                DocDocumentNo :list.docDocumentNo,
                DocIssuPlace :null,
                Createdby :null,
                Createddate :null,
                Updatedby :null,
                Updateddate :null,
                CompanyId :null,
                IsActive :null,
                UploadPath : null,
                FileName : null,
                Extension : null,
                Status : null
            }
        } ) 

        let VendorMaster = []
        if(this.state.type === 'edit'){
           
            Vendor.VendorId = this.props.match.params.id;  
            Vendor.Id = this.state.vid 
            
            
            var updatedVendorDocuments = VendorDocuments.map((doc) => {
                doc.Vendordocumentid = this.state.vendordocs[0].vendordocumentid;
                doc.Id = this.state.vendordocs[0].id;
                  return doc } )
                
                

            VendorMaster  = {
                    Vendor : Vendor,
                    VendorDocuments : updatedVendorDocuments
                } 
             } 
            
            
        

        if(this.state.type === 'add'){
            VendorMaster  = {
            Vendor : Vendor,
            VendorDocuments : VendorDocuments
        }}

        
        
        
        // this.props.processDynamicData('Vendor',this.state.type,VendorMaster,'Employee/GetVendor?VendorId=${this.props.match.params.id}');
        
        this.props.processDynamicData('Vendor',this.state.type,VendorMaster,'Employee/GetVendorList');  
    }

    resetData = () => {
        this.setState ({    
        docType : null,
        docDocumentNo : null,
        display : true,
        rows: [],
        type : 'add',
        City : null,
        Country : null,
        vendorId : '',
        vendorNo : '',
        businessType : '',
        vendordocs :[],
        VendorType : null,
        DocExpiryDate : '',
        DocIssuDate : '',
        vendorName : '',
        Address : '',
        billingName : '',
        billingPosition : '',
        billingEmail : '',
        timesheetName : '',
        timesheetPosition : '',
        timesheetEmail : '',
        procurementName : '',
        procurementPosition : '',
        procurementEmail : '',
        actionType : '',
        taxtIn : '',
        CrNo : '',
        bank : '',
        bankBranch : '',
        bankAddress : '',
        bankIban : '',
        isActive : false,
        Blocked : false,
        billingMobile: '',
        timesheetMobile : '',
        procurementMobile : '',
        rowData : null
        });        
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'percentage');
    }
    
    issuedEditor =  (props) => {
        return this.inputCalendarEditor(props, 'issuedDate');
    }

    expiryEditor =  (props) => {
        return this.inputCalendarEditor(props, 'expiryDate');
    }

    placeEditor =  (props) => {
        return this.inputTextEditor(props, 'issuedPlace');
    }

    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }
    
    inputCalendarEditor = (props, field) => {
        return <InputMask mask="99/99/9999" slotChar="dd/mm/yyyy" placeholder="Date" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />
        
    }

    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})

        // setTimeout(() => {
        //     this.checkDuration();
        // },2000)
        
        
    }

    // checkDuration = () => {
    //     if(this.state.LunchStart !=='' && this.state.LunchEnd !==''){
    //         let LunchStart = new moment(this.state.LunchStart);
    //         LunchStart = LunchStart.format("HH:mm");
    //         let LunchEnd = new moment(this.state.LunchEnd);
    //         LunchEnd = LunchEnd.format("HH:mm");
    //         let LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
    //         let checkTst = LunchDuration.split(':');
    //         if(checkTst[0] < 0  && checkTst[1] < 0){
    //             this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
    //         }else{
    //             this.setState({LunchDuration:LunchDuration})
    //         }
    //     }
    // }
    // VendorRender = (rowData) => {
        
    //     let vendorType = rowData.vendorType;
    //     let VendorType = '';

    //     if(this.props.VendorType && this.props.VendorType.length > 0){
    //         VendorName = this.props.VendorType.filter((type)=>{
    //             return type.value === vendorType
    //         }).reduce((result, el) => {
    //             return el.label;
    //         },'');
    //     }
    //     return VendorType;
    // }

    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/Vendor/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        let isEnabled = (this.state.touch === true);
        // let isEnabled = (this.state.shiftName!=='' && this.state.ShiftId!=='' && this.state.Description!=='');
        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Add Vendor</h1>
           
                        <div className="p-grid mt2">
                            
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Vendor Number<span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="vendorNo" value={this.state.vendorNo} placeholder="Vendor Number" onChange={this.change} /></div>                                
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Business Type <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="businessType" value={this.state.businessType}  placeholder="Business Type"  onChange={this.change}/></div>                                
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Vendor Type <span className="requiredColor" >*</span></label>
                                <Dropdown className="p-col-12" placeholder="Choose Vendor Type" options={this.props.VendorType} name="VendorType" value={this.state.VendorType} onChange={this.change}   {...DROPDOWN_CONFIG} />                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Vendor Name <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="vendorName" placeholder="Vendor Name" value={this.state.vendorName}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Address <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="Address" placeholder="Address" value={this.state.Address}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">City <span className="requiredColor">*</span></label>
                                <div className="mt1"> 
                                <Dropdown className="p-col-12" placeholder="Choose City" options={this.props.City} name="City" value={this.state.City} onChange={this.change}  {...DROPDOWN_CONFIG} />
                                </div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Country <span className="requiredColor">*</span></label>
                                <div className="mt1"> 
                                <Dropdown className="p-col-12" placeholder="Choose Country" options={this.props.Country} name="Country" value={this.state.Country} onChange={this.change}  {...DROPDOWN_CONFIG} />
                                </div>                                
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Company Id <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="companyId" placeholder="Company ID" value={this.state.companyId}  onChange={this.change}/></div>                                
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Action Type <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="actionType" placeholder="Action Type" value={this.state.actionType}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Taxtin <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="taxtIn" placeholder="taxtin" value={this.state.taxtIn}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">CR Number <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="CrNo" placeholder="CR Number" value={this.state.CrNo}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bank" placeholder="Bank" value={this.state.bank}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank Branch <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bankBranch" placeholder="Bank Branch" value={this.state.bankBranch}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank Address <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bankAddress" placeholder="bank Address" value={this.state.bankAddress}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Bank Iban <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="bankIban" placeholder="Bank Iban" value={this.state.bankIban}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                         
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="input" style={{ marginRight: '10px' }} >Active</label> 
                                        <InputSwitch checked={this.state.isActive} value={this.state.isActive} name="isActive" onChange={this.change}/> 
                                            
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="input" style={{ marginRight: '10px' }} >Blocked</label> 
                                        <InputSwitch checked={this.state.Blocked} value={this.state.Blocked} name="Blocked" onChange={this.change}/> 
                                            
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Billing" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name"  name="billingName" value={this.state.billingName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="billingPosition" value={this.state.billingPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email"  name="billingEmail" value={this.state.billingEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="billingMobile" value={this.state.billingMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Timesheet" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name" name="timesheetName" value={this.state.timesheetName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="timesheetPosition" value={this.state.timesheetPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email"  name="timesheetEmail" value={this.state.timesheetEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="timesheetMobile" value={this.state.timesheetMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Procurement" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Contact Person</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Name"  name="procurementName" value={this.state.procurementName} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Position</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Position"  name="procurementPosition" value={this.state.procurementPosition} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Email</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Email" name="procurementEmail" value={this.state.procurementEmail} onChange={this.change}/>
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Mobile</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <InputText placeholder="Mobile"  name="procurementMobile" value={this.state.procurementMobile} onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>
                            
                            

                            {/* <div className="p-col-12 p-md-6 p-lg-12 mt3">
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <div className="mt1">
                                        <Button onClick={this.documentAdd}  label="Add" className="p-button-primary"/>
                                    </div>                                
                                </div>
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.rows} editable={true}>
                                    <Column field="no" header="S.No"  style={{height: '3.5em'}}/>
                                    <Column field="hour" header="Hour"  style={{height: '3.5em'}}/>
                                    <Column field="percentage" header="Percentage" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.actionTemplate} header="Delete "style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                                </div> 
                            */}
                        </div> 
                            {/* <div className="mt3">
                                <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
                                    <Button label="Add" style={{marginBottom:'10px'}} className="p-button-primary" onClick={this.documentAdd}/>
                                </div>
                        
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.vendorTypes} editable={true}>
                                    <Column field="vendorType" header="Type" editor={this.typeEditor} style={{height: '3.5em'}}/>
                                    <Column field="documentType" header="Document Type" editor={this.docTypeEditor} style={{height: '3.5em'}}/>
                                    <Column field="doucmentNo" header="Document No" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column field="expiryDate" header="Expiry Date" editor={this.expiryEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedDate" header="Issued Date" editor={this.issuedEditor} style={{height: '3.5em'}}/>
                                    <Column field="issuedPlace" header="Issued Place" editor={this.placeEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.docActionTemplate} style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                            </div> */}
                            
                            <div className="mt3">
                <div className="p-grid">

                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Vendor Type</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.props.VendorType} name="vendorType" value={this.state.vendorType} onChange={event => this.setState({vendorType: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Vendor Type" style={{marginTop: '0.5em'}}/></div>   
                    </div>
                     */}
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Document Type</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="docType" onChange={event => this.setState({docType: event.target.value})}  value={this.state.docType} placeholder="Enter Document Type" style={{marginTop: '0.5em'}}/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Document Number</label>
                        <div className="mt1">
                        <InputText className="p-col-12" name="docDocumentNo" onChange={event => this.setState({docDocumentNo: event.target.value})}  value={this.state.docDocumentNo} placeholder="Enter Document Type" style={{marginTop: '0.5em'}}/>
                        </div>                             
                    </div>
                    {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Expiry Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocExpiryDate" onChange={event => this.setState({DocExpiryDate: event.target.value})}  value={this.state.DocExpiryDate} dateFormat="yy-mm-dd" placeholder="Choose Expiry Date"/>
                        </div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Issue Date</label>
                        <div className="mt1">
                        <Calendar className="p-col-12" name="DocIssuDate" onChange={event => this.setState({DocIssuDate: event.target.value})}  value={this.state.DocIssuDate} dateFormat="yy-mm-dd" placeholder="Choose Issue Date"/>
                        </div>                             
                    </div> */}
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label" style={{visibility:"hidden"}}>.</label>
                        <div className="mt1">
                        <Button label="Add"  className="p-button-primary" onClick={this.documentAdd}/>
                        </div>
                    </div>
           
                    <div className="p-col-12">
                    <DataTable className="animated fadeIn mt2" rowHover  emptyMessage="No records found..." responsive value={this.state.vendordocs} editable={true}>
                        {/* <Column field="vendorType" header="Type" style={{height: '3.5em'}} body={this.VendorRender}/> */}
                        <Column field="docType" header="Document Type" style={{height: '3.5em'}}/>
                        <Column field="docDocumentNo" header="Document Number" style={{height: '3.5em'}}/>
                        {/* <Column field="DocExpiryDate" header="Expiry Date"  style={{height: '3.5em'}}/>
                        <Column field="DocIssuDate" header="Issued Date" style={{height: '3.5em'}}/> */}
                        {/* if (this.state.type == 'add') { */}
                        <Column body={this.docActionTemplate} />
                        {/* if (this.state.type == 'edit') {
                        <Column body={this.docTemplate} />} */}
                    </DataTable> 
                    </div>

                </div>
            </div>  
                       
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton}  type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/Vendor"} />
                            </div>
                                 
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        City: (state.keyword.City!==undefined) ? state.keyword.City : [],
        Country : (state.keyword.Country!==undefined) ? state.keyword.Country : [],
        VendorType : (state.keyword.VendorType!==undefined) ? state.keyword.VendorType : [], 
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Vendor);